<section class="new-mmr-design">
  <section class="column">
    <section class="group">
      <claims-athome-myaccount-manage-my-repair-detail-group
        [groupTitle]="'TRACK_BOOKING'"
      >
        <p data-testid="booking-ref-title">
          Reference: {{ claimDetails.bookingReference }}
        </p>
        <p
          class="fault-selected"
          *ngIf="
            !nonEngineerOption &&
            claimType === 'REPAIR' &&
            claimDetails.faultSelected
          "
        >
          Fault: {{ claimDetails.faultSelected }}
        </p>

        <p class="last-updated" data-testid="last-updated">
          {{
            'MMR.LAST_UPDATED'
              | translate
                : { lastUpdated: lastUpdated | date : 'h:mma' | lowercase }
          }}
        </p>
        <claims-athome-myaccount-repair-tracker
          #repairTracker
          [appointmentHistory]="claimDetails.appointmentHistory"
          [isNonEngineerOption]="nonEngineerOption"
          [showCancelButton]="showCancelButton"
          [claimType]="claimType"
          [claimDetails]="claimDetails"
          [appointmentIsToday]="appointmentIsToday"
          [currentStatus]="claimDetails.claimStatus"
          [isHeatingPlan]="isHeatingPlan"
          [gadgetType]="gadgetType"
          [isFloocareProduct]="isFloocareProduct"
          [claimPaymentRequired]="isClaimPaymentRequired"
          (rebookClaim)="rebookClaim.emit()"
          (cancelClaim)="cancelClaim.emit()"
          (trackClaim)="trackClaim.emit()"
          [productCode]="productCode"
        >
        </claims-athome-myaccount-repair-tracker>
      </claims-athome-myaccount-manage-my-repair-detail-group>
    </section>

    <div class="horizontal-divider"></div>

    <section
      class="group"
      [ngClass]="nonEngineerOption ? 'collection-address' : ''"
    >
      <claims-athome-myaccount-manage-my-repair-detail-group
        *ngFor="let address of addressToShow"
        [groupTitle]="addressTitleKeyMap[address]"
      >
        <claims-athome-myaccount-manage-my-repair-detail-group-section>
          <section
            *ngIf="claimDetails[address]"
            style="display: flex; flex-direction: column"
            data-testid="return-address"
          >
            <p *ngIf="claimDetails[address].streetName" dgxQmSanitise="block">
              {{ claimDetails[address].streetName }}
            </p>
            <p *ngIf="claimDetails[address].localArea" dgxQmSanitise="block">
              {{ claimDetails[address].localArea }}
            </p>
            <p *ngIf="claimDetails[address].townCity" dgxQmSanitise="block">
              {{ claimDetails[address].townCity }}
            </p>
            <p *ngIf="claimDetails[address].postCode" dgxQmSanitise="block">
              {{ claimDetails[address].postCode }}
            </p>
          </section>
        </claims-athome-myaccount-manage-my-repair-detail-group-section>
      </claims-athome-myaccount-manage-my-repair-detail-group>
    </section>
  </section>

  <div class="vertical-divider"></div>

  <div class="horizontal-divider collapsed-view"></div>

  <section class="column">
    <!-- TODO: Bring this back once we have done the work on Orbit to return user friendly faults -->
    <!-- <section class="group" *ngIf="claimType === 'REPAIR'">
    <athome-myaccount-manage-my-repair-detail-group groupTitle="FAULT_DETAILS">
      <athome-myaccount-manage-my-repair-detail-group-section>
        <p>{{ claimDetails.faultSelected }}</p>
      </athome-myaccount-manage-my-repair-detail-group-section>
    </athome-myaccount-manage-my-repair-detail-group>
  </section> -->

    <section class="group">
      <claims-athome-myaccount-manage-my-repair-detail-group
        [groupTitle]="groupTitleAndBody.title"
      >
        <p>
          {{
            'MMR.' + groupTitleAndBody.body
              | translate
                : {
                    claimType: claimType | lowercase,
                    provider:
                      claimType === 'REPAIR' ? 'repairer' : 'service provider'
                  }
          }}
        </p>
        <p *ngIf="groupTitleAndBody.subBody">
          {{ 'MMR.' + groupTitleAndBody.subBody | translate }}
        </p>
        <p class="amend-gap repairer-name">
          {{ formattedRepairerName }}
        </p>
        <claims-athome-myaccount-manage-my-repair-detail-group-section
          iconName="phone"
        >
          <p>
            <a
              [phone]="claimDetails.repairer.phone_number"
              class="link not-clickable-on-desktop"
              (click)="trackEngineerContact('Need support - call phone')"
              >{{ claimDetails.repairer.phone_number }}</a
            >
          </p>
        </claims-athome-myaccount-manage-my-repair-detail-group-section>
        <div class="amend-gap card">
          <claims-dg-home-myaccount-contact-hours
            [contactHours]="claimDetails.repairer.contactHours"
            class="contact-hours"
            [showOpeningHoursTitle]="false"
            (click)="trackEngineerContact('show contact hours')"
          >
          </claims-dg-home-myaccount-contact-hours>
        </div>

        <p
          *ngIf="callCostType"
          class="typog-caption call-cost"
          [innerHTML]="'MMR.TELEPHONE.' + callCostType | translate"
        ></p>
        <claims-athome-myaccount-manage-my-repair-detail-group-section
          *ngIf="isEligibleProvider && claimDetails.repairer.email"
          iconName="envelope"
        >
          <a
            [href]="'mailto:' + claimDetails.repairer.email"
            class="link amend-gap"
            (click)="trackEngineerContact('email')"
            >{{ claimDetails.repairer.email }}</a
          >
        </claims-athome-myaccount-manage-my-repair-detail-group-section>

        <!--        <ng-container *ngIf="!submittedTrackerSurvey[claimDetails.id]">-->
        <!--          <hr class="feedback-divider" />-->

        <!--          &lt;!&ndash; test feedback capture component&ndash;&gt;-->
        <!--          <claims-athome-myaccount-feedback-capture-component-->
        <!--            *ngIf="isMMRFeedbackCaptureEnabled"-->
        <!--            [feedbackConfig]="feedbackCaptureConfig"-->
        <!--            [handlerWhenFormSubmitted]="feedbackGAHandler"-->
        <!--          >-->
        <!--          </claims-athome-myaccount-feedback-capture-component>-->

        <!--          &lt;!&ndash; original feedback capture component&ndash;&gt;-->
        <!--          <claims-athome-myaccount-feedback-component-->
        <!--            *ngIf="!isMMRFeedbackCaptureEnabled"-->
        <!--            [feedbackConfig]="feedbackConfig"-->
        <!--            [handlerWhenFormSubmitted]="feedbackGAHandler"-->
        <!--          >-->
        <!--          </claims-athome-myaccount-feedback-component>-->
        <!--        </ng-container>-->
      </claims-athome-myaccount-manage-my-repair-detail-group>
    </section>
    <div class="horizontal-divider-update" style="display: none"></div>

    <section class="group" *dgxFeatureEnabled="mmrLiveChatEnabledFlag">
      <claims-athome-myaccount-manage-my-repair-detail-group
        [groupTitle]="'OTHER_QUESTIONS'"
      >
        <p class="typog-body">
          {{ 'MMR.OTHER_QUESTIONS_BODY' | translate }}
        </p>

        <dgx-components-button
          variant="secondary"
          class="CTA-btn"
          [fill]="true"
        >
          {{ 'MMR.CHAT_BOX_CTA' | translate }}
        </dgx-components-button>
      </claims-athome-myaccount-manage-my-repair-detail-group>

      <ng-template #StandardNextSteps>
        <claims-athome-myaccount-manage-my-repair-detail-group-section>
          <p>{{ nextAction }}</p>
        </claims-athome-myaccount-manage-my-repair-detail-group-section>
      </ng-template>
    </section>
  </section>
</section>
